import React from 'react';
import { Grid, FormControl, InputLabel, TextField } from '@mui/material';

const DateInputComponent = ({ formData, handleDateChange, handleInputChange, styled, inputStyles, isDesktop, field, instruct, border }) => {
    return (
        <Grid item xs={12} md={6} key={field.name}>
            <Grid container alignItems="center" spacing={1}>
                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                    <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>

                </Grid>
                <Grid item xs>
                    <FormControl fullWidth>
                        {field.type === 'date' ? (
                            <TextField
                                id={field.name}
                                name={field.name}
                                type="date"
                                value={formData[field.name]}
                                onChange={handleDateChange}
                                inputProps={{ style: styled.cutDate }}
                                sx={inputStyles}
                            />
                        ) : (
                            <>
                                <TextField
                                    id={field.name}
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={(e) => handleInputChange(e)}
                                    inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                    sx={inputStyles}
                                />
                                {instruct ? <span style={{color:'red'}}>{instruct}</span> : null}
                            </>
                        )}
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DateInputComponent;
